import isEmpty from 'lodash/isEmpty';

const getLabelTooltipText = (isStudentVisible, labels) => {
  const toolTipText = isStudentVisible
    ? 'Labels with assignments shown to students'
    : 'All labels hidden from students';
  const noLabelTooltipText = 'Create a label to show it to students';
  return isEmpty(labels) ? noLabelTooltipText : toolTipText;
};

export default getLabelTooltipText;
